import { useState, useEffect, useCallback, useMemo } from 'react';
import { useFetchData } from './apiHooks';

export function useEmailAnswerHistory(emailId, emailResponse, handleAnswerChange) {
    const { data: emailAnswerHistory, setData: setEmailAnswerHistory, isLoading, error, refetch } = useFetchData(`/email/${emailId}/history`, null, false);
    const [currentVersion, setCurrentVersion] = useState(() => emailAnswerHistory?.length - 1 ?? null);

    const fetchHistory = useCallback(async () => {
        if (emailId) {
            try {
                const historyData = await refetch();
                setCurrentVersion(historyData?.length - 1 ?? null);
            } catch (error) {
                console.error('Error fetching history:', error);
            }
        }
    }, [emailId, refetch]);

    useEffect(() => {
        if (emailId) {
            fetchHistory(); 
        }
    
        return () => {
            setCurrentVersion(null);
            setEmailAnswerHistory(null);
        };
    }, [fetchHistory, setEmailAnswerHistory]);

    const reduceVersion = useCallback(() => {
        if (currentVersion > 0 && emailAnswerHistory) {
            const newVersion = currentVersion - 1;
            handleAnswerChange('body', emailAnswerHistory[newVersion].change);
            setCurrentVersion(newVersion);
        }
    }, [currentVersion, emailAnswerHistory, handleAnswerChange]);
    
    const increaseVersion = useCallback(() => {
        if (emailAnswerHistory && currentVersion < emailAnswerHistory.length - 1) {
            const newVersion = currentVersion + 1;
            handleAnswerChange('body', emailAnswerHistory[newVersion].change);
            setCurrentVersion(newVersion);
        }
    }, [currentVersion, emailAnswerHistory, handleAnswerChange]);

    const changeEditorAndVersion = useCallback(async (content, is_user_input=true, debounce=true) => {
        console.log('changeEditorAndVersion', emailId)
        if (!emailId) return;
    
        try {
            const currentHistory = emailAnswerHistory || await refetch();
            const updatedHistory = [...currentHistory, { change: content }];
            setEmailAnswerHistory(updatedHistory);
            setCurrentVersion(updatedHistory.length - 1);
            handleAnswerChange('body', content, is_user_input, debounce)
        } catch (error) {
            console.error('Error updating history:', error);
        }
    }, [emailId, emailAnswerHistory, refetch, emailResponse, handleAnswerChange]);
    
    const versionControls = useMemo(() => ({
        reduceVersion,
        increaseVersion,
        hasLowerVersion: currentVersion > 0,
        hasHigherVersion: currentVersion < (emailAnswerHistory?.length - 1),
        isLoading,
    }), [currentVersion, emailAnswerHistory, isLoading, reduceVersion, increaseVersion]);

    return { changeEditorAndVersion, versionControls, currentVersion, error, refetch };
}


